import { type FC } from 'react'

export const CartIntermediateSpecialOffersImageDecorator: FC = () => null
